import { VOOrchestra } from "../model/DataStructure.js";
import { Labels } from "../model/Labels.js";
import { DiamondButton } from "./DiamondButton.js";

export interface OrchestraDetailOptions {
    container: HTMLElement;
    orchestra?: VOOrchestra;
    labels: Labels;
    onSelect?: (orchestra: VOOrchestra) => void;
    onVideoEnd?: () => void;
}

export class OrchestraDetail {
    public readonly onSelect = e5.Signal.create<[VOOrchestra]>();
    public readonly onVideoEnd = e5.Signal.create();

    private _element: HTMLDivElement;
    private _orchestra: VOOrchestra = null;
    private _video: HTMLVideoElement;
    private _title: HTMLDivElement;
    private _subtitle: HTMLDivElement;
    private _description: HTMLDivElement;
    private _start: DiamondButton;
    private _active: boolean = true;

    constructor(options: OrchestraDetailOptions) {
        this._element = document.createElement("div");
        this._element.className = "orchestra-detail";
        this._element.innerHTML = `
        <div class="orchestra-detail__left">
            <div class="orchestra-detail__video-wrapper">
                <video class="orchestra-selector__video"></video>
                <div class="orchestra-detail__left-gradient"></div>
            </div>
        </div>
        <div class="orchestra-detail__right">
            <div class="orchestra-detail__title"></div>
            <div class="orchestra-detail__subtitle"></div>
            <div class="orchestra-detail__separator"></div>
            <div class="orchestra-detail__description"></div>
            <div class="orchestra-detail__start"></div>
        </div>`;

        this._video = this._element.querySelector<HTMLVideoElement>(".orchestra-selector__video");
        this._title = this._element.querySelector(".orchestra-detail__title");
        this._subtitle = this._element.querySelector(".orchestra-detail__subtitle");
        this._description = this._element.querySelector(".orchestra-detail__description");



        this._video.volume = 1;
        this._video.autoplay = false;
        // this._video.loop = true;
        this._video.addEventListener("ended", () => {
            if (!this._active) {
                return;
            }
            this._video.currentTime = 0;
            this._video.play().catch(() => { });
            this.onVideoEnd.dispatch();
        });

        this._start = new DiamondButton({
            label: options.labels.text("orchestra.orchestra_detail.button.start"),
            container: this._element.querySelector(".orchestra-detail__start"),
            onClick: (e) => {
                if (this._orchestra) {
                    this.onSelect.dispatch(this._orchestra)
                }
            }
        });

        if (typeof options.onSelect === "function") {
            this.onSelect.add(options.onSelect);
        }

        if (typeof options.onVideoEnd === "function") {
            this.onVideoEnd.add(options.onVideoEnd);
        }

        if (options.orchestra) {
            this.orchestra = options.orchestra;
        }

        if (options.container) {
            options.container.appendChild(this._element);
        }
    }

    public async hide() {
        this.active = false;
        this._element.classList.toggle("orchestra-detail--hidden", true);
        return new Promise((resolve) => {
            gsap.to(
                [
                    this._element.querySelector(".orchestra-detail__right"),
                    this._element.querySelector(".orchestra-selector__video")
                ],
                {
                    duration: 0.25,
                    opacity: 0,
                    onComplete: () => {
                        resolve(true);
                    }
                });
        });
    }

    public async show() {
        this._element.classList.toggle("orchestra-detail--hidden", false);
        this.active = true;
        return new Promise((resolve) => {
            gsap.to(
                [
                    this._element.querySelector(".orchestra-detail__right"),
                    this._element.querySelector(".orchestra-selector__video")
                ],
                {
                    duration: 0.25,
                    opacity: 1,
                    onComplete: resolve
                });
        });
    }

    public set active(value: boolean) {
        if (this._active === value) {
            return;
        }
        this._active = value;

        gsap.to(this._video, {
            duration: 0.25,
            volume: this._active ? 1 : 0,
            onComplete: () => {
                if (this._active) {
                    this._video.play().catch(() => { });
                } else {
                    this._video.pause();
                }
            }
        });
    }

    public get active(): boolean {
        return this._active;
    }

    public get orchestra(): VOOrchestra {
        return this._orchestra;
    }

    public set orchestra(value: VOOrchestra) {
        if (this._orchestra === value) {
            return;
        }
        this._orchestra = value;

        if (!value) {
            // this._video.pause();
            // this.active = false;
            return;
        }

        this._element.querySelector<HTMLElement>(".orchestra-detail__left-gradient")
            .style.setProperty("--color-start", value.color);

        this._title.textContent = value.name;
        this._subtitle.textContent = value.subtitle;
        this._description.textContent = value.description;
        this._video.width = value.video.width;
        this._video.height = value.video.height;
        this._video.src = value.video.url;
        this._video.style.aspectRatio = `${value.video.width} / ${value.video.height}`;
        this._video.play().catch(() => {
            this._video.volume = 0;
            this._video.play().catch(() => { });
        });
    }
}